import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { AccessRoleDTO } from '../../../api/access-role-api';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import {
    FormikCellToggle,
    FormikDateInput,
    FormikNumberInput,
    FormikTextField,
} from '../../../components/formik';
import { yup } from '../../../components/basic/yup';
import SvgSave from '../../../assets/icons/Save';
import SvgDelete from '../../../assets/icons/Delete';
import SvgClose from '../../../assets/icons/Close';

interface SaveAccessRoleModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedAccessRole?: AccessRoleDTO;
    onHide: () => void;
    onSave: (values: AccessRoleDTO) => void;
    onDelete?: (accessRole: AccessRoleDTO) => void;
}

export function SaveAccessRoleModal({
    show,
    allowEdit,
    selectedAccessRole,
    onHide,
    onSave,
    onDelete,
}: SaveAccessRoleModalProps) {
    const AccessRoleSchema = yup.object().shape({
        id: yup.string().required(' '),
        title: yup.string(),
    });

    const defaultValues: AccessRoleDTO = {
        id: selectedAccessRole ? selectedAccessRole.id : '',
        title: selectedAccessRole ? selectedAccessRole.title : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={AccessRoleSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedAccessRole ? 'edit-access-role' : 'new-access-role'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedAccessRole && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedAccessRole)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="id"
                                name="id"
                                readOnly={!allowEdit || !!selectedAccessRole}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
